import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "sonner";
import LoginPage from "./pages/LoginPage";
import DashboardLayout from "./pages/DashboardLayout";
import DashboardPage from "./pages/DashboardPage";
import ProductsPage from "./pages/ProductsPage";
import ProductFormPage from "./pages/ProductFormPage";
import BulkUploadPage from "./pages/BulkUploadPage";
import CatalogsPage from "./pages/CatalogsPage";
import CatalogBuilderPage from "./pages/CatalogBuilderPage";
import CorporateCatalogsPage from "./pages/CorporateCatalogsPage";
import CorporateCatalogBuilderPage from "./pages/CorporateCatalogBuilderPage";
import TaxonomyPage from "./pages/TaxonomyPage";
import UsersPage from "./pages/UsersPage";
import SettingsPage from "./pages/SettingsPage";
import SharedCatalogPage from "./pages/SharedCatalogPage";
import SharedMobilePage from "./pages/SharedMobilePage";
import FlipbookPage from "./pages/FlipbookPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center">
      <div className="spinner-gold" />
    </div>
  );
  if (!user) return <Navigate to="/login" />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/shared/:token" element={<SharedCatalogPage />} />
          <Route path="/shared-mobile/:token" element={<SharedMobilePage />} />
          <Route path="/flipbook/:token" element={<FlipbookPage />} />
          <Route path="/" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="products/new" element={<ProductFormPage />} />
            <Route path="products/:id/edit" element={<ProductFormPage />} />
            <Route path="catalogs" element={<CatalogsPage />} />
            <Route path="catalogs/new" element={<CatalogBuilderPage />} />
            <Route path="catalogs/:id/edit" element={<CatalogBuilderPage />} />
            <Route path="corporate-catalogs" element={<CorporateCatalogsPage />} />
            <Route path="corporate-catalogs/new" element={<CorporateCatalogBuilderPage />} />
            <Route path="corporate-catalogs/:id/edit" element={<CorporateCatalogBuilderPage />} />
            <Route path="taxonomy" element={<TaxonomyPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="bulk-upload" element={<BulkUploadPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
